import React, { useEffect } from 'react';
import { useArticlesGetAll } from '../../../../../hooks/api/articles';
import TippingArticleList from '../../ArticlesList';

import styles from '../../index.module.scss';

export default function MostRecent(): React.ReactNode | null {
  const articlesGetAll = useArticlesGetAll();
  const { data } = articlesGetAll;

  useEffect(() => {
    articlesGetAll.fetch({ pageSize: 3 });
  }, []);

  return (
    <div className={styles.MostRecent}>
      <TippingArticleList articles={data?.data || []} style={{ marginTop: 0 }} />
    </div>
  );
}
